var map = {
	"./icon_download.svg": 30086,
	"./icon_left.svg": 14364,
	"./icon_right.svg": 162,
	"./icon_video_mute.svg": 79551,
	"./icon_video_start.svg": 40664,
	"./icon_video_stop.svg": 80841,
	"./icon_video_volume.svg": 41916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;